import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import HandleMissedRent from './component';
import { closeNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import DismissibleActionConstants from '@common/constants/DismissibleActionConstants';

const mapStateToProps = (state) => {
  const { userConfig, dismissibleActions } = state.payments.landlord.property;
  const { isRentGuaranteeEnabled } = userConfig;
  return {
    isRentGuaranteeEnabled,
    dismissibleActions,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl }) => ({
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl))),
  goToSetupPaymentPlan: (dismissibleActions) =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() =>
        dismissibleActions[DismissibleActionConstants.PAYMENT_PLAN_INSTRUCTIONS]
          ? dispatch(push(baseUrl + paths.dashboard.howToSetupPaymentPlan))
          : dispatch(push(baseUrl + paths.dashboard.PaymentPlanInstallmentRequests)),
      ),
});

const mergeProps = (stateProps, dispatchProps) => {
  const { dismissibleActions } = stateProps;
  return {
    ...stateProps,
    ...dispatchProps,
    goToSetupPaymentPlan: () => dispatchProps.goToSetupPaymentPlan(dismissibleActions),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(HandleMissedRent);
